var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.5,3.5c-1.7,0-3-1.4-3-3C11.5,0.2,11.3,0,11,0H8.5C8.2,0,8,0.2,8,0.5v10.3c0,1-0.8,1.8-1.8,1.8s-1.8-0.8-1.8-1.8\n\tc0-1,0.8-1.8,1.8-1.8c0.3,0,0.5-0.2,0.5-0.5V6c0-0.3-0.2-0.5-0.5-0.5C3.4,5.5,1,7.9,1,10.8S3.4,16,6.2,16s5.2-2.3,5.2-5.2V6.2\n\tc0.9,0.5,2,0.8,3,0.8C14.8,7,15,6.8,15,6.5V4C15,3.7,14.8,3.5,14.5,3.5z","fill":"currentColor"}));
}

Tiktok.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Tiktok;

Tiktok.default = Tiktok;
